import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/crm/sales-order/{id}/deliver`。SHIPPING → DELIVERED。body：`updatedAt`。 */
export async function deliverSalesOrder(id, payload = {}) {
  const { data: raw } = await request.post(
    `/crm/sales-order/${id}/deliver`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
